import { Component, Input, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterComponent } from '../component-lookup';
import { UserService } from '../../../shared/services/user.service';
import { StateService } from '../../services/state.service';
import { Institution, InstitutionType } from '../../services/institution.service';
import { InstitutionAutocompleteComponent } from '../institution-autocomplete/institution-autocomplete.component';

@RegisterComponent('InstitutionSelector')
@Component({
  selector: 'app-institution-selector',
  standalone: true,
  imports: [CommonModule, InstitutionAutocompleteComponent],
  templateUrl: './institution-selector.component.html',
  styleUrl: './institution-selector.component.scss'
})
export class InstitutionSelectorComponent {
  institutionAutocomplete = viewChild.required('institutionAutocomplete', { read: InstitutionAutocompleteComponent });
  @Input() isLocked = false;
  
  readonly user = inject(UserService).state;

  private stateService = inject(StateService);
  readonly institution= this.stateService.institution;
  readonly userInstitutions = this.stateService.userInstitutions;

  readonly isPrinting = this.stateService.isPrinting;

  InstitutionType = InstitutionType;
  institutionType = InstitutionType.all;
  selectedInstitution?: Institution;
  isOpen = false;

  toggle() {
    if (!this.isLocked) {
      this.isOpen = !this.isOpen;
      if (this.user().organizationType == 'MULTI') {
        if (this.isOpen) {
          this.institutionAutocomplete().setFocus();
        }
        else {
          this.selectedInstitution = undefined;
          this.institutionAutocomplete().clearInstitution();
        }
      }
    }
  }

  onSelectInstitution(institution: Institution) {
    this.selectedInstitution = institution;
  }

  clearInstitution() {
    this.institutionAutocomplete().clearInstitution();
  }

  switch() {
    if (this.selectedInstitution != undefined) {
      this.switchTo(this.selectedInstitution);
    }
  }

  switchTo(institution: Institution) {
    this.toggle();
    setTimeout(() => {
      this.stateService.setInstitution(institution);
    }, 300);
    this.stateService.updateUserInstitutionLastViewed(institution);
  }

  add() {
    if (this.selectedInstitution != undefined) {
      this.stateService.addUserInstitution(this.selectedInstitution);
    }
  }

  remove(institution: Institution) {
    this.stateService.removeUserInstitution(institution);
  }
}
